// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VlS5","badges":"styles_badges__21y6t"};